import { useContext, useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Spinner from '../../UI/Modal/Spinner';
import Inputs from './components/Inputs';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../../Context/TabContext';

const INITIAL_VALUES = {
  id: 0,
  nazivFirme: '',
  adresa: '',
  kontaktTelefon: '',
  email: '',
};

const KlijentiPregled = ({ save, handleSave, novi, handleNovi }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const { addTab } = useContext(TabContext);

  const [formData, setFormData] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const vratiGrid = () => {
    const config = {
      url: urls.GET_KUPCI,
    };
    sendRequest(config);
  };
  useEffect(() => {
    vratiGrid();
  }, []);

  useEffect(() => {
    if (novi) {
      setFormData(INITIAL_VALUES);
      const tab = {
        title: 'Klijent',
        icon: 'fas fa-clipboard',
        type: 10013,
      };
      addTab(tab);
      handleNovi(false);
    }
  }, [novi]);

  const handleSaveData = async () => {
    const config = {
      method: 'POST',
      url: formData.id === 0 ? urls.INSERT_KUPAC : urls.UPDATE_KUPAC,
      data: {
        id: formData.id,
        nazivFirme: formData.nazivFirme,
        adresa: formData.adresa,
        kontaktTelefon: formData.kontaktTelefon,
        email: formData.email,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      setFormData(INITIAL_VALUES);
      vratiGrid();
      toast.success(
        formData.id === 0 ? 'Uspešan unos klijenta' : 'Uspešna izmena klijenta',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);

  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_KUPAC,
      data: { id: formData.id },
    };
    const result = await getData(config);

    if (result > 0) {
      vratiGrid();
      toast.success('Uspešano obrisan podatak');
      setOpenDeleteDialog(false);
      setFormData(INITIAL_VALUES);
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  const handleEditData = (item) => {
    const tab = {
      title: 'Klijent',
      icon: 'fas fa-clipboard',
      type: 10013,
      data: item,
    };
    addTab(tab);
    setFormData(item);
  };
  const handleOpenDeleteDialog = (id) => {
    setFormData({ ...formData, id: id });
    setOpenDeleteDialog(true);
  };
  const openMasine = (item) => {
    const tab = {
      title: 'Mašine',
      icon: 'fas fa-cogs',
      type: 68,
      data: { idKlijenta: item.id },
    };
    addTab(tab);
  };
  return (
    <div>
      {isLoading && <Spinner />}
      {/* <Inputs formData={formData} setFormData={setFormData} /> */}
      <GridProvider
        data={data}
        handleEditData={handleEditData}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        isLoading={isLoading}
        openMasine={openMasine}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KlijentiPregled;
